import { parseHtml, useMessageChannelContext } from '@healthhub/react-ui';
import { Typography } from 'antd';
import DOMPurify from 'dompurify';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { SCAM_SHIELD_LINK } from '@shared/constants/paths';
import { useGetMessageSettingsQuery } from '@shared/services/systemSettings';
import { layoutSelector } from '@shared/stores/layout/layoutSelector';
import { layoutAction } from '@shared/stores/layout/layoutSlice';
import { useAppDispatch, useAppSelector } from '@shared/stores/rootTypes';
import { MESSAGE_ACTION } from '@shared/utils/bridge';

import { ANTISINGOV_MESSAGE_PORTAL_CODE } from '@features/Home/constants';

import AntiSinGovWrapper from './AntiSinGovWrapper';

const { Text } = Typography;

const AntiSinGovNotice = () => {
  const { t } = useTranslation('home');
  const dispatch = useAppDispatch();
  const [isImportantNoticeShown, setIsImportantNoticeShown] = useState(false);
  const { showGlobalAntiSinGovNotice, showGlobalImportantNotices } = useAppSelector(layoutSelector);
  const { sendMessageToNative } = useMessageChannelContext();

  const {
    data: antiSinGovNoticeData,
    error: isAntiSinGovHasError,
    isFetching: isAntiSinGovFetching,
  } = useGetMessageSettingsQuery({
    Codes: [ANTISINGOV_MESSAGE_PORTAL_CODE],
  });

  const handleIconCloseClick = () => {
    dispatch(layoutAction.setShowGlobalAntiSinGovNotice(false));
  };

  const handleScamWebSiteLinkClick = () => {
    sendMessageToNative(MESSAGE_ACTION.externalLink({ url: SCAM_SHIELD_LINK }));
  };

  useEffect(() => {
    if (showGlobalImportantNotices === false) {
      setIsImportantNoticeShown(false);
      return;
    }

    setIsImportantNoticeShown(true);
  }, [showGlobalImportantNotices]);

  if (isAntiSinGovHasError) {
    return (
      <AntiSinGovWrapper handleIconCloseClick={handleIconCloseClick} isImportantNoticeShown={isImportantNoticeShown}>
        <Trans
          components={{
            1: <Text className="text-sm" />,
            2: <Text className="text-sm font-semibold text-secondary-green-500" />,
            3: (
              <Text
                className="cursor-pointer font-semibold text-secondary-green-500"
                onClick={handleScamWebSiteLinkClick}
              />
            ),
          }}
          i18nKey={t('antiSinGovNoticePresetValue')}
        />
      </AntiSinGovWrapper>
    );
  }

  if (isAntiSinGovFetching || showGlobalAntiSinGovNotice === false || !antiSinGovNoticeData?.[0]?.Value) {
    return null;
  }

  return (
    <AntiSinGovWrapper handleIconCloseClick={handleIconCloseClick} isImportantNoticeShown={isImportantNoticeShown}>
      <div>
        {parseHtml(
          DOMPurify.sanitize(antiSinGovNoticeData?.[0]?.Value || '', {
            ALLOWED_ATTR: ['href', 'target', 'rel', 'style'],
          })
        )}
      </div>
    </AntiSinGovWrapper>
  );
};

export default AntiSinGovNotice;
